<template>
  <div class="container my-14 grid grid-cols-6 lg:my-20 lg:grid-cols-12">
    <div class="col-span-6 lg:col-span-8 lg:col-start-3">
      <StructuredText :data="data.body" />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { SectionBodyRecord } from 'types/generated'

defineProps({
  data: {
    type: Object as PropType<SectionBodyRecord>,
    default: () => {}
  }
})
</script>
